<template>
  <b-card
    no-body
    class="overall-privilege-card p-5 p-sm-0"
  >
    <b-row class="h-100">
      <b-col
        cols="12"
        class="d-flex align-items-center justify-content-center h-100"
      >
        <b-row>
          <b-col
            cols="12"
            class="text-center"
          >
            <span class="privilege-point">{{ formData.point }} คะแนน</span>
          </b-col>
          <b-col
            cols="12"
            class="text-center"
            v-if="formData.expDate != null"
          >
            <span>แต้มจะหมดอายุภายใน</span>
          </b-col>
          <b-col
            cols="12"
            class="text-center"
            v-if="formData.expDate != null"
          >
            <span>{{ formData.expDate }}</span>
          </b-col>
          <b-col
            cols="12"
            class="text-center"
            v-if="formData.tierTh != null"
          >
            <b-badge
              pill
              class="mt-1 rank-badge"
            >
              <span class="privilege-rank">{{ formData.tierTh }}</span>
            </b-badge>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </b-card>
</template>

<script>
import {
  BCard, BRow, BCol, BBadge,
} from 'bootstrap-vue'
import useOverallPrivilege from '../hooks/useOverallPrivilege'

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BBadge,
  },
  setup() {
    const { formData } = useOverallPrivilege()
    return {
      formData,
    }
  },
}
</script>

<style></style>

<style scoped>
@import '~@/assets/css/pages/data-management/overall-privilege.css';
</style>
